import moment from "moment";


export const DISMANTLING_DATES_REQUIRED_TOGETHER =
    "FORMS.Validation_DismantlingDatesRequiredTogether";
export const DISMANTLING_END_BEFORE_START =
    "FORMS.Validation_DismantlingEndBeforeStart";


const toValidMoment = (value) => {
    if (!value) return null;

    const dateTime = moment.isMoment(value) ?
        value.clone() :
        moment(value, moment.ISO_8601, true);

    return dateTime.isValid() ? dateTime : null;
};


export const getDismantlingInitialValues = (event) => ({
    dismantling_start_at: toValidMoment(event?.dismantling_start_at),
    dismantling_end_at: toValidMoment(event?.dismantling_end_at),
});


export const getSuggestedDismantlingEnd = (startAt) => {
    const start = toValidMoment(startAt);

    return start ? start.add(1, "day") : null;
};


export const getDismantlingPeriodValidationError = (startAt, endAt) => {
    const hasStart = Boolean(startAt);
    const hasEnd = Boolean(endAt);

    if (hasStart !== hasEnd) return DISMANTLING_DATES_REQUIRED_TOGETHER;
    if (!hasStart) return null;

    const start = toValidMoment(startAt);
    const end = toValidMoment(endAt);

    if (!start || !end || end.isBefore(start)) {
        return DISMANTLING_END_BEFORE_START;
    }

    return null;
};


export const buildEventMutationInput = (eventID, values) => ({
    id: eventID ? +eventID : undefined,
    ...values,
});
